import { BlankResponse } from '../../../models/LessonComponentContent';
import { FillBlankComponent } from '../../../models/LessonComponent';
import { FillGap } from './FillGap';
import React from 'react';

interface IFillGapElementProps {
  node: Node;
  onChange: (id: string, value: string) => void;
  component: FillBlankComponent;
  answers: BlankResponse[];
}
enum NodeTypes {
  ELEMENT = 1,
  ATTR = 2,
  TEXT = 3,
  CDATASECTION = 4
}

export const FillGapRecursiveElement = (props: IFillGapElementProps) => {
  const { node, answers } = props;
  const children = Array.from(node.childNodes).map((childNode, index) => (
    <FillGapRecursiveElement {...props} key={index} node={childNode} />
  ));
  /** nodeName returns in UPPERCASE. So it is required to be lowercase
   * when creating element with this nodeName.
   */
  const tag = node.nodeName;
  const el = node as HTMLElement;
  const id = el.getAttribute && el.getAttribute('id');
  const css = el.style;
  const styles =
    css &&
    Array.from(css).reduce(
      (prev, curr) => ({ ...prev, [curr]: css[curr] }),
      {}
    );

  //Render the text content if there is any TEXT node
  if (node.nodeType === NodeTypes.TEXT) {
    return <>{node.textContent}</>;
  }
  //Render each element using React.createElement
  if (node.nodeType === NodeTypes.ELEMENT) {
    let attributeObj = { style: styles };
    attributeObj['className'] = el.getAttribute('class');
    if (tag === 'A') {
      attributeObj['href'] = el.getAttribute('href');
      attributeObj['target'] = el.getAttribute('target');
    }

    switch (tag) {
      case 'BLANK':
        const value = answers.find((ans) => ans.id === id)?.answer;
        return <FillGap id={id} value={value} {...props} />;
      case 'BR':
      case 'HR':
        return React.createElement(tag.toLocaleLowerCase());
      default:
        return React.createElement(
          tag.toLocaleLowerCase(),
          attributeObj,
          children
        );
    }
  }
};
